import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  annual_investment_return_rate: {
    name: 'Expected annual investment return',
    order: 137
  }
};

export function MarketRiskProfile({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.MARKET_RISK_PROFILE,
    onChangeFund,
    schema: schema.MARKET_RISK_PROFILE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MARKET_RISK_PROFILE?.field_names || [],
    columnLables,
    tableName: 'MARKET_RISK_PROFILE',
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-market-risk-profile-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
